module.exports = __webpack_public_path__ + "static/img/WechatIMG26.8ae2652e.jpeg";